import { User } from '@auth0/auth0-react';
import { UserMeta } from '../components/pm/models';
import {
  AUTH0_ROLES_KEY,
  ConeProduct,
  GlobalAuth0Role,
} from './constants/common';

const SUPER_ADMIN_ROLES = [GlobalAuth0Role.SuperAdmin];

export const getRolesFromAuth0User = (user: User | undefined): string[] => {
  return user?.[AUTH0_ROLES_KEY] || [];
};

export const isSuperAdminUser = (user: User | undefined): boolean => {
  const roles = getRolesFromAuth0User(user);
  return SUPER_ADMIN_ROLES.some((role) => roles.includes(role));
};

export const isPmProductUser = (userMeta?: UserMeta): boolean =>
  Boolean(userMeta?.products?.includes(ConeProduct.PM));

export const isP2PProductUser = (userMeta?: UserMeta): boolean =>
  Boolean(userMeta?.products?.includes(ConeProduct.P2P));

export const isPmClientProductUser = (userMeta?: UserMeta): boolean =>
  Boolean(userMeta?.products?.includes(ConeProduct.PM_CLIENT));
